import React, { useState } from "react";
import { ToastContainer, Toast } from "react-bootstrap";
import "./Common.css";
import { adminAxios } from "../services/api";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    feedback: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contact") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length > 10) return;
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.contact || !formData.feedback) {
      setToast({ show: true, message: "Please fill in all fields", type: "danger" });
      return;
    }

    if (formData.contact.length !== 10) {
      setToast({ show: true, message: "Contact number must be exactly 10 digits", type: "danger" });
      return;
    }

    try {
      setIsSubmitting(true);
      await adminAxios.post("/feedback", formData);

      setToast({ show: true, message: "Feedback submitted successfully!", type: "success" });
      setFormData({
        name: "",
        email: "",
        contact: "",
        feedback: "",
      });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setToast({ show: true, message: "Failed to submit feedback. Please try again.", type: "danger" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="feedback-section">
      <div className="container">

        <div className="text-center mb-5">
          <span className="feedback-tag">GET IN TOUCH</span>

          <h1 className="feedback-title">
            Feedback / Suggestion Form
          </h1>

          <p className="feedback-subtitle">
            Submit your feedback & suggestion
          </p>
        </div>

        <div className="feedback-card">
          <div className="row g-3">

            <div className="col-md-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control feedback-input"
                placeholder="Name *"
              />
            </div>

            <div className="col-md-4">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control feedback-input"
                placeholder="Email Address *"
              />
            </div>

            <div className="col-md-4">
              <input
                type="text"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                className="form-control feedback-input"
                placeholder="Contact *"
                maxLength="10"
              />
            </div>

            <div className="col-md-8">
              <input
                type="text"
                name="feedback"
                value={formData.feedback}
                onChange={handleChange}
                className="form-control feedback-input"
                placeholder="Feedback/Suggestion *"
              />
            </div>

            <div className="col-md-4 d-flex align-items-center">
              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit Feedback \u00a0\u279c"}
              </button>
            </div>

          </div>
        </div>

      </div>

      <ToastContainer position="top-end" className="p-3" style={{ position: 'fixed', zIndex: 1050 }}>
        <Toast
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
          bg={toast.type}
        >
          <Toast.Body className={toast.type === "light" || toast.type === "warning" ? "text-dark" : "text-white"}>
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </section>
  );
};

export default Feedback;